import { persistFindRemoteLogsNow, flushFindRemoteLogs } from './sink';

let registered = false;

export function registerFindRemoteLogLifecycle() {
  if (registered) {
    return () => {};
  }
  registered = true;

  const onBackground = () => {
    void persistFindRemoteLogsNow();
    void flushFindRemoteLogs('background');
  };

  if (typeof document !== 'undefined') {
    document.addEventListener('visibilitychange', () => {
      if (document.visibilityState === 'hidden') {
        onBackground();
      }
    });
  }

  return onBackground;
}
